<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <h1>{{ 'SIGNUP_DOMAIN_CREATION' | translate }}</h1>
    </div>
    <div class="body">
        <div class="loading-spinner-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </div>
</div>